var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover-placeholder"},[_vm._v("暂无图片")])}
var staticRenderFns = []

export { render, staticRenderFns }